import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QrCodeSection } from "./components/qr-section/qr-section";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./landing-mobile-app.module.css";
import { WhyAppInformation } from "./components/why-app/why-app";
import { Head } from "@cinch-nx/landing-ui-shared";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
export const LandingMobileApp = ({ story , generatedAt , preview  })=>{
    const { body  } = story.content;
    const qrSectionData = body.find((qrdata)=>qrdata.component === "QR Section");
    const whyAppSectionData = body.find((whyAppData)=>whyAppData.component === "Why Section");
    const hasQrSection = qrSectionData;
    const hasWhyAppSection = whyAppSectionData;
    const { content  } = useStoryblokState({
        story,
        enableBridge: preview
    });
    const [SEO] = (content === null || content === void 0 ? void 0 : content.SEO) ?? [
        {}
    ];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "App - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: {
                    container: styles.qrWrapper
                },
                children: hasQrSection && /*#__PURE__*/ _jsx(QrCodeSection, {
                    sectionData: qrSectionData
                })
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                backgroundColor: "#F2F5FF",
                children: hasWhyAppSection && /*#__PURE__*/ _jsx(WhyAppInformation, {
                    heading: whyAppSectionData.title,
                    listOfItems: whyAppSectionData.icon_list,
                    ariaLabelForList: "why app information section",
                    disclaimer: whyAppSectionData.disclaimer
                })
            })
        ]
    });
};
